import React from 'react';
import { useTranslation } from 'react-i18next';

export const ModalBodyHandHelpGuest = () => {
  const { t } = useTranslation();

  return <p className="text-xs font-light">{t('modal-hand-help-guest')}</p>;
};
